<template>
  <button
    data-html2canvas-ignore
    @click="$emit('click')"
    class="mobile-button__reset"
    :style="{ color: color, borderBottomColor: color }"
  >
    <span :style="{ fontSize: fontSize }">重設</span>
  </button>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      default: '#dcdcdc',
    },
    fontSize: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
button {
  &.mobile-button {
    &__reset {
      background: none;
      border: none;
      border-bottom: 1px solid #dcdcdc;
      padding: 0;

      &:focus {
        outline: none;
      }
    }
  }
}
</style>
